// extracted by mini-css-extract-plugin
export default {"page":"StartPage_page__TSIcO","welcomeSegment":"StartPage_welcomeSegment__pZhNZ","companyLogoSegment":"StartPage_companyLogoSegment__HlH6d"};